import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import authService from '../services/authService';
import './LoginPage.css';

export default function PasswordResetRequestPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      await authService.requestPasswordReset(email);
      setSubmitted(true);
    } catch (requestError) {
      setError(requestError?.message || 'Unable to send the reset email. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="card login-page__card">
        {submitted ? (
          <>
            <div className="login-page__eyebrow">Check your inbox</div>
            <h1 className="login-page__title">Reset link requested</h1>
            <p className="login-page__description">
              If an account exists for <strong>{email}</strong>, we sent instructions to reset its password.
              Check your spam folder if you do not see the email.
            </p>
            <Link to="/login" className="login-page__submit login-page__submit--link">Back to sign in</Link>
          </>
        ) : (
          <>
            <div className="login-page__eyebrow">Account recovery</div>
            <h1 className="login-page__title">Forgot your password?</h1>
            <p className="login-page__description">
              Enter the email address for your account and we’ll send you a secure reset link.
            </p>

            <form onSubmit={onSubmit} className="login-page__form">
              <label className="login-page__label">
                Email
                <input
                  className="login-page__input"
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  autoComplete="email"
                  required
                />
              </label>

              {error ? <div className="login-page__error">{error}</div> : null}

              <button type="submit" disabled={submitting} className="login-page__submit">
                {submitting ? 'Sending…' : 'Send reset link'}
              </button>
            </form>

            <p className="login-page__links">
              Remember your password? <Link to="/login">Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
